export default __webpack_public_path__ + "static/media/whatsapp.348b108f.png";